import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FabricanteEditarComponent } from './fabricante-editar.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: ':id', component: FabricanteEditarComponent }
    ])],
    exports: [RouterModule]
})
export class FabricanteEditarRoutingModule { }
